import { LoadingIndicator } from '@oolio-group/design-ui-react';

export const LoadingSpinner = () => {
  return <LoadingIndicator color="var(--accent)" loading size="small" />;
};
